var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _g, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 108,
    viewBox: "0 0 150 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.913 44.11l8.319-.737L83.69 59.85l-8.319.736-1.458-16.478z",
    fill: "#60717D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.594 44.846l8.319-.737 1.458 16.478-8.318.737-1.459-16.478z",
    fill: "#60717D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6 27.544a8.508 8.508 0 017.113-9.822l43.585-6.751c4.71-.73 9.161 2.486 9.942 7.18l2.619 15.745a8.508 8.508 0 01-7.113 9.823l-43.585 6.75c-4.71.73-9.16-2.485-9.942-7.18l-2.62-15.745z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.06 29.734a8.508 8.508 0 017.112-9.822l43.585-6.751c4.71-.73 9.161 2.485 9.943 7.18l2.619 15.745a8.508 8.508 0 01-7.113 9.822L59.621 52.66c-4.71.73-9.161-2.485-9.942-7.18l-2.62-15.745z",
    fill: "#B9E1FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6 27.544a8.508 8.508 0 017.113-9.822l43.585-6.751c4.71-.73 9.161 2.486 9.942 7.18l2.619 15.745a8.507 8.507 0 01-7.113 9.823l-43.585 6.75c-4.71.73-9.16-2.485-9.942-7.18l-2.62-15.745z",
    stroke: "#60717D",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.108 44.11c6.102-.957 10.229-6.724 9.216-12.882-1.012-6.158-6.78-10.374-12.881-9.417-6.103.956-10.229 6.724-9.217 12.881 1.013 6.158 6.78 10.374 12.882 9.418zM90.016 39.63c6.103-.957 10.229-6.724 9.217-12.882-1.013-6.158-6.78-10.374-12.882-9.417-6.102.956-10.228 6.724-9.216 12.881 1.012 6.158 6.78 10.374 12.881 9.418z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.956 37.102c2.267-.356 3.8-2.498 3.423-4.785-.376-2.287-2.518-3.853-4.784-3.498-2.267.355-3.8 2.498-3.423 4.785.375 2.287 2.518 3.853 4.784 3.498zM88.864 32.621c2.267-.355 3.8-2.497 3.423-4.784-.376-2.287-2.518-3.853-4.784-3.498-2.267.355-3.8 2.497-3.423 4.785.376 2.287 2.518 3.853 4.784 3.497z",
    fill: "#B9E1FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.81 68.057L37.94 55.69l-4.736 5.308 13.87 12.366 4.736-5.307z",
    fill: "#A3B1BD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.799 56.456l-6.522-14.92 5.555-5.39 8.418 16.321-7.451 3.99z",
    fill: "#A3B1BD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.23 28.1l5.032 4.121a4.153 4.153 0 00-.116 3.746c.973 2.078 3.46 2.962 5.554 1.973 2.095-.99 3.004-3.476 2.03-5.555a4.116 4.116 0 00-2.6-2.215l.048-6.403c3.39.447 6.477 2.545 8.027 5.856 2.434 5.196.161 11.413-5.075 13.886-5.236 2.473-11.453.265-13.886-4.932-1.647-3.517-1.138-7.503.987-10.478z",
    fill: "#60717D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.077 61.636a5.334 5.334 0 005.3-5.3 5.218 5.218 0 00-5.252-5.252 5.334 5.334 0 00-5.3 5.3 5.218 5.218 0 005.252 5.252z",
    fill: "#60717D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.05 61.111l13.87-12.366 4.736 5.307-13.87 12.367-4.736-5.307z",
    fill: "#A3B1BD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.061 49.51l6.522-14.92-5.555-5.389-8.418 16.321 7.451 3.989z",
    fill: "#A3B1BD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.629 21.154l-5.032 4.122a4.15 4.15 0 01.117 3.745c-.973 2.08-3.46 2.962-5.555 1.973-2.094-.989-3.003-3.476-2.03-5.554a4.117 4.117 0 012.6-2.215l-.047-6.403c-3.391.447-6.477 2.544-8.027 5.855-2.434 5.197-.161 11.414 5.075 13.887 5.236 2.473 11.453.265 13.886-4.932 1.647-3.518 1.138-7.503-.987-10.478z",
    fill: "#60717D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M116.783 54.69a5.334 5.334 0 01-5.3-5.3 5.217 5.217 0 015.251-5.251 5.334 5.334 0 015.3 5.3 5.218 5.218 0 01-5.251 5.251z",
    fill: "#60717D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "robot_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 17,
    width: 91,
    height: 91
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.86,
    cy: 62.795,
    r: 45,
    fill: "#F795A4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#robot_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.86 65.732c0-5.488 3.833-9.937 8.561-9.937h43.878c4.728 0 8.561 4.45 8.561 9.937v58.063h-61V65.732z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.86 67.878c0-5.568 3.833-10.083 8.561-10.083h43.878c4.728 0 8.561 4.515 8.561 10.083v58.917h-61V67.878z",
    fill: "#B9E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.86 66.17c0-5.73 3.833-10.375 8.561-10.375h43.878c4.728 0 8.561 4.645 8.561 10.376v60.624h-61V66.171z",
    stroke: "#60717D",
    strokeWidth: 2
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.142 67.605v4.78h-.84v-4.78h-1.28v-.79h3.397v.79h-1.277zm1.768 4.376c0-.135.05-.251.148-.35a.482.482 0 01.353-.148c.137 0 .255.05.354.148a.483.483 0 01.148.353c0 .14-.05.26-.148.358a.48.48 0 01-.354.144.49.49 0 01-.501-.505zm3.149-5.166v5.57h-.84v-5.57h.84zm1.31 5.166c0-.135.049-.251.147-.35a.482.482 0 01.354-.148c.137 0 .255.05.353.148a.483.483 0 01.148.353c0 .14-.05.26-.148.358a.48.48 0 01-.353.144.49.49 0 01-.501-.505zm5.58-.949h-2.385l-.62 1.353h-.906l2.756-5.92 2.659 5.92h-.92l-.584-1.353zm-.343-.79l-.826-1.894-.866 1.894h1.692zm2.792 1.739c0-.135.05-.251.148-.35a.482.482 0 01.353-.148c.138 0 .255.05.354.148a.483.483 0 01.148.353c0 .14-.05.26-.148.358a.48.48 0 01-.354.144.49.49 0 01-.501-.505z",
    fill: "#fff"
  })));
}
export default SvgRobot;